import Axios from 'axios';
import { INCOME, APIBASE_URL } from '../config/cacheKey';
import {
    IDocumentPropertiesResponse,
    IGetInfoResponse,
    IGetOrganizationAdditionalDocumentRequest,
    IRegisterRequest,
    IUpdateRequest
} from '../models/income.model';
import {
    IRefrenceKeyRequest
} from '../models/registration.model';
import {
    IRegisterDocumentRequest,
    IDocumentResponse,
    IDocumentRequest
} from '../models/identity.model';

import { ApiResultModel } from '../models/common.model';
import { toast } from 'react-toastify';




export const getIncomeRangeOptions = (): Promise<IDocumentPropertiesResponse[]> => {
    return Axios.post<ApiResultModel<IDocumentPropertiesResponse[]>>(
        APIBASE_URL + INCOME + '/GetIncomeRangeOptions'
    ).then((result) => {
        return result.data.data;
    });
};

export const getInfo = (data: IRefrenceKeyRequest): Promise<IGetInfoResponse> => {
    return Axios.post<ApiResultModel<IGetInfoResponse>>(
        APIBASE_URL + INCOME + '/GetInfo',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const register = (
    request: IRegisterRequest
): Promise<boolean> => {
    const formData = new FormData();
    formData.append("incomeRangeOptionId", request.incomeRangeOptionId + "");
    formData.append("jobTitle", request.jobTitle);
    formData.append("jobOrganization", request.jobOrganization!);
    formData.append("jobAddress", request.jobAddress!);
    formData.append("referenceKey", request.referenceKey);
    request.files?.forEach((item: any) => {
        formData.append("files", item, item.name);
    })
    return Axios.post<ApiResultModel<boolean>>(
        APIBASE_URL + INCOME + '/Register',
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data; charset=utf-8',
                Accept: 'multipart/form-data',
            },
        }
    ).then((result) => {
        return result.data.data;
    });
};

// export const register = (data: IRegisterRequest): Promise<boolean> => {
//     return Axios.post<ApiResultModel<boolean>>(
//         APIBASE_URL + INCOME + '/Register',
//         data
//     ).then((result) => {
//         return result.data.data;
//     });
// };

export const update = (data: IUpdateRequest): Promise<boolean> => {
    return Axios.post<ApiResultModel<boolean>>(
        APIBASE_URL + INCOME + '/Update',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const registerDocument = (
    request: IRegisterDocumentRequest
): Promise<IDocumentResponse> => {
    const formData = new FormData();
    formData.append("documentType", request.documentType);
    formData.append("base64Date", request.base64Date);
    formData.append("referenceKey", request.referenceKey);
    formData.append("data", request.data, request.data.name);
    return Axios.post<ApiResultModel<IDocumentResponse>>(
        APIBASE_URL + INCOME + '/RegisterDocument',
        formData
    ).then((result) => {
        return result.data.data;
    });
};

export const removeDocument = (data: IDocumentRequest): Promise<boolean> => {
    return Axios.post<ApiResultModel<boolean>>(
        APIBASE_URL + INCOME + '/RemoveDocument',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const getDocument = (data: IDocumentRequest): Promise<IDocumentResponse> => {
    return Axios.post<ApiResultModel<IDocumentResponse>>(
        APIBASE_URL + INCOME + '/GetDocument',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const GetOrganizationAdditionalDocument = async (data: IGetOrganizationAdditionalDocumentRequest) => {
    return await Axios({
        method: "POST",
        url: APIBASE_URL + INCOME + "/GetOrganizationAdditionalDocument",
        data,
        responseType: "blob",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/pdf",
        },
    }).then((response: any) => {
        if (response.headers['content-type'] === 'application/json') {
            const reader = new FileReader();
            reader.onload = () => {
                const jsonResponse = JSON.parse(reader.result as string);
                if (jsonResponse && jsonResponse.isSuccess === false && jsonResponse.messages) {
                    const errorMessages = jsonResponse.messages[0].message;
                    toast.error(errorMessages);
                }
            };
            reader.readAsText(new Blob([response.data]));
        } else {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", ` ${data.additionalDocumentTypeTitle}.pdf`);
            document.body.appendChild(link);
            link.click();
        }


    }).catch((error) => {
        console.error("Error occurred:", error.message);
        throw error;
    });
};